import React from 'react'
import { useTranslation } from 'react-i18n-lite'
import { NavigationSlider, useIsMobile } from '@yes.technology/react-toolkit'
import { useFilterFieldsContext } from '../../context'
import { useSectionNavigation } from '../Section/SectionContext'
import CommonControls from './CommonControls'
import { CenterWrapper } from './GroupControls.styles'
import type { CenterHeaderElementProps } from './CenterHeaderElement.types'

const CenterHeaderElement = ({ onRemoveClick }: CenterHeaderElementProps) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const { sectionPosition, setSectionPosition, sectionsLength } =
    useSectionNavigation()
  const { config, styling } = useFilterFieldsContext()
  const { enableComposition } = config
  const { navigationSliderBackgroundColor, navigationSliderColor } = styling

  return (
    <CenterWrapper>
      <NavigationSlider
        ignoreHeight
        heightClass='small'
        className='pb-2 pb-lg-0'
        currentPosition={sectionPosition}
        first={1}
        total={sectionsLength}
        afterClick={setSectionPosition}
        textForCurrent={t('filter-fields.section')}
        hierarchyLevel='level_4'
        backgroundColor={navigationSliderBackgroundColor}
        color={navigationSliderColor}
      />
      {isMobile && enableComposition && (
        <CommonControls onRemoveClick={onRemoveClick} />
      )}
    </CenterWrapper>
  )
}

export default CenterHeaderElement
